module.exports = __webpack_public_path__ + "media/images/members/alicia_vara_lopez-7279115c9d881c5a8ed0409b123ccd37.jpg";